import * as utility from "./services.js"
import * as react_components from "./reactcomponent.js"
import * as translations_editor from "./uieditor/translations_editor.js"
import * as propertyTypes from "./property_types.js"
import { TemplateEditorControl } from "./property_editor/template_editor.js"
import { Innosoft_InnoBI_Controllers_ApiBuilderController as ApiBuilder } from "./generated_api/generated_api.js"
import { UiBuildertoolBar } from "./components/ui_builder_toolbar.js"
import { EntityFieldPicker } from "./uieditor/entityField_editor.js"
import { DialogHelper } from "../core/util/dialogHelper.js";
import { FontAwesomePicker } from "./uieditor/fontawesome_icon_editor.js";
import { Button } from "../core/components/button.js";
import { DictionaryEditor, DictionaryPropertyControl } from "./uieditor/dictionaryEditor.js";
import { StatisticPickerControl } from "./uieditor/statistics_selector.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { SearchHelper } from "../core/util/searchfieldHelper.js";
import { Helper } from "../core/util/helper.js"
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { TranslatableTextEditor } from "./property_editor/translatable_text_editor.js"
import React from "react"
export class UiBUilderTextEditor extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = { currentValue: props.value, initialValue: props.value };
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ currentValue: props.value });
    }

    handleChange = (event) => {
        let value: string = event.target.value;
        if (this.props.onlyUpperCase && value) {
            value = value.toUpperCase();
        } else if (this.props.onlyNumbersAllowed) {
            if (!Helper.isNumber(value) && value) {
                value = this.state.currentValue;
            }
        }

        this.setState({ currentValue: value, initialValue: this.props.value });
    }

    handleBlur = (event) => {
        if (this.state.currentValue !== this.state.initialValue) {
            this.props.onTextChange(event.target.value == '' ? null : (this.props.onlyNumbersAllowed && event.target.value ? Number(event.target.value) : event.target.value));
        }
    }

    render() {
        const mandatoryIndicator = this.props.isMandatory ? <span style={{ color: "red" }}>*</span> : null;
        let style: React.CSSProperties = {};
        if (this.props.isReadOnly) {
            style.backgroundColor = "#ddd";
        }

        return (
            <li>
                <div title={this.props.label}>
                    <span className="property-name">{this.props.label} {mandatoryIndicator} </span>
                    <div className="c">
                        <input style={style} type="text" readOnly={this.props.isReadOnly} defaultValue='' value={Helper.hasValue(this.state.currentValue) ? this.state.currentValue : ''} onChange={this.handleChange} onBlur={this.handleBlur} />                    </div>
                </div>
            </li>)
    }
};

export class UiBUilderCheckBox extends React.Component<any, any> {
    handleChange = (event) => {
        this.props.onTextChange(event.target.checked);
    }

    render() {
        return (
            <li>
                <div title={this.props.label}>
                    <span className="property-name">{this.props.label}</span>
                    <div className="c">
                        <input type="checkbox" checked={this.props.value == null ? this.props.defaultValue : this.props.value} onChange={this.handleChange} />
                    </div>
                </div>
            </li>)
    }
};

export class UiBUilderTextCheckBox extends React.Component<any, any> {
    handleChange = (newValue) => {
        this.props.onTextChange(newValue);
    }

    handleTypeChanged = (selectedValue) => {
        if (selectedValue.target.value == "constant") {
            this.props.onTextChange(false);
        }
        else {
            this.props.onTextChange("");
        }
    }

    getFieldType = (value) => {
        return typeof (this.props.value) !== "string" ? "constant" : "expression";
    }

    render() {
        const editor = this.getFieldType(this.props.value) == "constant" ? <UiBUilderCheckBox label={this.props.label} value={this.props.value || false} onTextChange={this.handleChange} />
            : <UiBUilderTextEditor label={this.props.label} value={this.props.value || false} onTextChange={this.handleChange} />

        return <>
            <select value={this.getFieldType(this.props.value)} style={{ width: "100%" }} onChange={this.handleTypeChanged}>
                <option value="constant">Constant</option>
                <option value="expression">Expression</option>
            </select>
            {editor}
        </>
    }
};


export class UiBuilderFolder extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = { collapsed: true };
    }

    handleClick = () => {
        var collapsed = this.state.collapsed;
        this.setState({ collapsed: !collapsed });
    }

    render() {
        var children: any = <div></div>;
        var className = "closed";
        if (!this.state.collapsed) {
            children = this.props.children;
            className = "";
        }
        return (
            <li className="folder">
                <div className="dg">
                    <ul className={className}>
                        <li className="title" style={{ display: "inline-flex", width: "100%" }} onClick={this.handleClick}>{this.props.label}{this.props.button}</li>
                        {children}
                    </ul>
                </div>
            </li>)
    }
};

export class UiBUilderSelect extends React.Component<any, any> {

    handleChange = (event) => {
        const selectText = event.target.value;
        const seletedValue = this.props.options.filter(x => x.Key == selectText)[0]
        if (seletedValue) {
            this.props.onTextChange(seletedValue.Key);
        }
    }

    createOptions = (o) => {
        return (<option key={o.Key} value={o.Key}>{o.Value}</option>);
    }

    render() {
        var options = this.props.options.map(this.createOptions);
        return (
            <li>
                <div title={this.props.label}>
                    <span className="property-name">{this.props.label}</span>
                    <div className="c">
                        <select onChange={this.handleChange} value={typeof this.props.value !== 'undefined' ? this.props.value : ''}>
                            <option value={''}></option>
                            {options}
                        </select>
                    </div>
                </div>
            </li>
        )
    }
};

export class ItemHeader extends React.Component<any, any> {
    handleChange = (event) => {
        this.props.onTextChange(event.target.value);
    }

    createOptions = (o) => {
        return (<option key={o.Key} value={o.Key}>{o.Value}</option>);
    }

    render() {
        let optionList = null;
        if (this.props.options && this.props.options.length > 1) {
            optionList = <select style={{ height: "25px" }} onChange={this.handleChange} value={this.props.value}>
                <option value={null}></option>
                {this.props.options.map(this.createOptions)}
            </select>

        }

        return (
            <li style={{ height: "28px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div title={this.props.label} style={{ display: "flex" }}>
                    <ButtonScalor> <Button iconName="trash" title="Delete item" handleClick={this.props.onDeleteClicked}>{"\u274C"}</Button></ButtonScalor>
                    <ButtonScalor><Button iconName="chevron-up" title="Move one up" readOnly={this.props.moveUpDisabled} handleClick={this.props.onMoveUpClicked}>{"\u25b2"} </Button></ButtonScalor>
                    <ButtonScalor><Button iconName="chevron-down" title="Move one down" readOnly={this.props.moveDownDisabled} handleClick={this.props.onMoveDownClicked}>{"\u25bc"} </Button></ButtonScalor>
                    {optionList}
                </div>
            </li>
        )
    }
};

interface PropertiesEditorProps {
    componentState?
    properties?
    selectedElement?
    onSettingsChanged?
    contextVariables?
    translatedMetadata?
    translations?
    entityFields?
    customComponentResolver?: (type: string) => { component: typeof React.Component, customProps: any }
};

export class PropertiesEditor extends React.Component<PropertiesEditorProps, any> {
    constructor(props) {
        super(props);
    }

    handleValueChanged = (name: string, value: string, translatedValue: string) => {
        let rawMetadata = this.props.selectedElement;
        let translatedMetadata = this.props.translatedMetadata;
        rawMetadata[name] = value;

        if (translatedMetadata) {

            translatedMetadata[name] = translatedValue ? translatedValue : value;
        }

        this.props.onSettingsChanged(rawMetadata, translatedMetadata);
    }

    render() {
        return (
            <div>
                <ObjectPropertiesEditor
                    properties={this.props.properties}
                    contextVariables={this.props.contextVariables}
                    selectedElement={this.props.selectedElement}
                    onValueChanged={this.handleValueChanged}
                    selectedRootElement={this.props.selectedElement}
                    componentState={this.props.componentState}
                    translations={this.props.translations}
                    entityFields={this.props.entityFields}
                    customComponentResolver={this.props.customComponentResolver} />
            </div>);
    }
};

interface ObjectPropertiersEditorProps {
    properties?
    contextVariables?
    selectedElement?
    onValueChanged?
    selectedRootElement?
    componentState?
    translations?
    entityFields?
    level?
    customComponentResolver?: (type: string) => { component: typeof React.Component, customProps: any }
}

class ObjectPropertiesEditor extends React.Component<ObjectPropertiersEditorProps, any> {
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ selectedElement: nextProps.selectedElement });
    }

    handleValueChanged = (name, value, isTranslatableProperty: boolean = false) => {
        let translatedString = null;
        if (isTranslatableProperty && this.props.translations) {
            translatedString = this.processCustomTemplate(value);
        }
        this.props.onValueChanged(name, value, translatedString);
    }

    processCustomTemplate(targetString: string): string {
        let filledTemplate = targetString;
        const regExp = new RegExp(`{{{.*?}}}`, "gm");
        const matches = filledTemplate.match(regExp)

        if (Array.isArray(matches)) {
            for (let i = 0; i < matches.length; i++) {
                const match = matches[i];
                const translationKey = match.replace("{{{", "").replace("}}}", "");
                const translation = this.props.translations[translationKey];
                filledTemplate = filledTemplate.replace(match, translation);
            }
        }

        return filledTemplate;
    }

    handleAddRow = (element, propertyMetadata) => {
        if (!Array.isArray(element)) {
            element = [];
        }
        var instance = propertyMetadata.createNewStateImplementationInstance(propertyMetadata.getAllKeys()[0]);
        element.push(instance);

        this.props.onValueChanged(propertyMetadata.ValueField, this.arrayToJSON(element));
    }

    arrayToJSON(array: any[]): any[] {
        return array.map(x => x.toJSON());
    }

    handleObjectChanged = (objectName, name, value) => {
        let element;
        if (!this.props.selectedElement) {
            element = {};
        }
        else {
            element = this.props.selectedElement[objectName];
        }

        if (!element) {
            element = {};
        }

        element[name] = value;
        this.props.onValueChanged(objectName, element);
    }

    handleObjectChangedExt = (objectName, name, value, objectMetadata: propertyTypes.ObjectPropertyExt) => {
        let element;

        if (!this.props.selectedElement) {
            element = {};
        }
        else {
            element = this.props.componentState[objectName];
        }

        let state = element;
        if (!state) {
            state = objectMetadata.createNewStateImplementationInstance(objectMetadata.getAllKeys()[0]);
        }

        state[name] = value;
        this.props.onValueChanged(objectName, state.toJSON ? state.toJSON() : state);
    }

    handleObjectTypeChanged = (objectMetadata: propertyTypes.ObjectPropertyExt, key: string) => {
        let element;

        if (!this.props.selectedElement) {
            element = {};
        }
        else {
            element = this.props.componentState[objectMetadata.ValueField];
        }

        let state = element;
        state = objectMetadata.createNewStateImplementationInstance(key);

        this.props.onValueChanged(objectMetadata.ValueField, state.toJSON ? state.toJSON() : state);
    }

    createOptions = (o) => {
        return (<option key={o.Key} value={o.Key}>{o.Value}</option>);
    }

    typeToControl = (propertyMetadata, index) => {
        var value;
        var that = this;
        if (this.props.selectedElement) {
            value = this.props.selectedElement[propertyMetadata.ValueField];
        }
        if (propertyMetadata.Type === propertyTypes.PropertyTypes.TEXT) {
            return <UiBUilderTextEditor isMandatory={propertyMetadata.IsMandatory}
                isReadOnly={propertyMetadata.IsReadOnly}
                onlyNumbersAllowed={propertyMetadata.OnlyNumbers}
                key={index} contextVariables={this.props.contextVariables} label={propertyMetadata.Label} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} value={value} onlyUpperCase={propertyMetadata.OnlyUpperCase} level={this.props.level || 0} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.CHECKBOX) {
            return <UiBUilderCheckBox key={index} contextVariables={this.props.contextVariables} defaultValue={propertyMetadata.DefaultValue} label={propertyMetadata.Label} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} value={value} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.TEXTCHECKBOX) {
            return <UiBUilderTextCheckBox key={index} contextVariables={this.props.contextVariables} label={propertyMetadata.Label} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} value={value} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.SELECT) {
            return <UiBUilderSelect key={index} contextVariables={this.props.contextVariables} label={propertyMetadata.Label} options={propertyMetadata.Options} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} value={value} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.SERVICESELECTOR) {
            return <ServicePickerControl key={index}
                contextVariables={this.props.contextVariables}
                label={propertyMetadata.Label}
                value={value}
                onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)}
                export={propertyMetadata.Export}
                useOnlyServiceID={propertyMetadata.UseOnlyServiceId}
                dataSourceType={propertyMetadata.DataSourceType} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.TEMPLATEEDITOR) {
            return <TemplateEditorControl key={index} contextVariables={this.props.contextVariables} label={propertyMetadata.Label} width={12} value={value} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.TRANSLATABLETEXTARRAYPROPERTY) {
            return <TranslatableTextEditor
                key={index}
                label={propertyMetadata.Label}
                value={value}
                languageFieldName={propertyMetadata.LanguageFieldName || "language"}
                translationFieldName={propertyMetadata.TranslationFieldName || "translation"}
                onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.COLUMNPICKER) {
            return <ColumnPickerControl key={index} contextVariables={this.props.contextVariables} meta={propertyMetadata} label={propertyMetadata.Label} width={12} value={value} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)} serviceProperty={propertyMetadata.ServiceProperty} selectedRootElement={that.props.selectedRootElement} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.TRANSLATIONPICKER) {
            return <TranslationPickerControl key={index} label={propertyMetadata.Label} contextVariables={this.props.contextVariables} width={12} value={value} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value, true)} serviceProperty={propertyMetadata.ServiceProperty} selectedRootElement={that.props.selectedRootElement} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.DICTIONARYEDITOR) {
            return <DictionaryPropertyControl key={index} label={propertyMetadata.Label} contextVariables={this.props.contextVariables} width={12} value={value} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value, false)} serviceProperty={propertyMetadata.ServiceProperty} selectedRootElement={that.props.selectedRootElement} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.STATISTICPROPERTY) {
            return <StatisticPickerControl key={index} label={propertyMetadata.Label} contextVariables={this.props.contextVariables} value={value} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value, false)} />
        }
        //else if (propertyMetadata.Type === propertyTypes.PropertyTypes.DOCUMENTPICKER) {
        //    return <DocumentPickerControl key={index} label={propertyMetadata.Label} value={value} onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value, false)} />
        //}
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.NOTEDITABLEPROPERTY) {
            return null;
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.ENTITYFIELDPICKER) {
            return <EntityFieldPicker
                key={index}
                label={propertyMetadata.Label}
                contextVariables={this.props.contextVariables}
                width={12}
                value={value}
                onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value, false)}
                serviceProperty={propertyMetadata.ServiceProperty}
                selectedRootElement={that.props.selectedRootElement}
                entityFields={this.props.entityFields} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.FONTAWESOMEICON) {
            return <FontAwesomePicker
                key={index}
                label={propertyMetadata.Label}
                contextVariables={this.props.contextVariables}
                width={12}
                value={value}
                onTextChange={(value) => that.handleValueChanged(propertyMetadata.ValueField, value, false)}
                serviceProperty={propertyMetadata.ServiceProperty}
                selectedRootElement={that.props.selectedRootElement}
                entityFields={this.props.entityFields} />
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.OBJECTEXT) {
            value = this.props.componentState[propertyMetadata.ValueField];
            const meta = propertyMetadata as propertyTypes.ObjectPropertyExt;
            let options;

            let propsByKey;
            let instance = value;
            if (!instance) {
                instance = meta.createNewStateImplementationInstance(meta.getAllKeys()[0]);
            }
            propsByKey = instance.getMetadata();

            if (meta.getAllKeys().length > 1) {
                options = meta.getAllKeys().map((k) => { return <option key={k} value={k}>{k}</option> });
            }

            let level = this.props.level || 0;
            const bu = options && options.length > 0 ? (
                <div className="c" style={{ float: "right" }}>
                    <select
                        style={{ width: "100%" }} onClick={(e) => { e.stopPropagation() }}
                        value={value ? value["_Object_Type"] : null}
                        onChange={(e: any) => { this.handleObjectTypeChanged(meta, e.target.value); }}>
                        <option key="" value={null}></option>
                        {options}
                    </select>
                </div>
            )
                : null
            let editor: any = React.createElement(ObjectPropertiesEditor, {
                translations: this.props.translations,
                properties: propsByKey,
                componentState: instance,
                selectedElement: value,
                onValueChanged: (name, value) => that.handleObjectChangedExt(propertyMetadata.ValueField, name, value, meta),
                level: meta.RenderInline ? level : ++level,
                selectedRootElement: that.props.selectedRootElement,
                contextVariables: that.props.contextVariables,
                customComponentResolver: this.props.customComponentResolver
            });

            if (!meta.RenderInline) {
                editor = <UiBuilderFolder key={index} label={propertyMetadata.Label} level={level} button={bu}>
                    {editor}
                </UiBuilderFolder>
            }

            return editor;
        }
        else if (propertyMetadata.Type === propertyTypes.PropertyTypes.OBJECT_LIST_EXT) {
            value = this.props.componentState[propertyMetadata.ValueField];
            const meta = propertyMetadata as propertyTypes.ObjectListPropertyExt;
            var level = this.props.level || 0;
            const button = meta.IsReadOnly ? null : <ButtonScalor><Button iconName="plus" title="Add item" handleClick={(e) => { e.stopPropagation(); this.handleAddRow(value, propertyMetadata); }}></Button></ButtonScalor>
            return <UiBuilderFolder key={index} label={propertyMetadata.Label} button={button}>
                <ListPropertiesEditorExt
                    level={++level}
                    propertyMetadata={meta}
                    contextVariables={this.props.contextVariables}
                    properties={propertyMetadata}
                    selectedElement={value}
                    onValueChanged={(value) => that.handleValueChanged(propertyMetadata.ValueField, value)}
                    label={propertyMetadata.Label}
                    selectedRootElement={that.props.selectedRootElement}
                    isReadOnly={meta.IsReadOnly}
                    translations={this.props.translations}
                    customComponentResolver={this.props.customComponentResolver}
                />
            </UiBuilderFolder>
        }
        else {
            if (this.props.customComponentResolver) {
                value = this.props.componentState[propertyMetadata.ValueField];
                const resolvedEditor = this.props.customComponentResolver(propertyMetadata.Type);
                if (resolvedEditor) {
                    const props: any = {
                        onTextChange: (value) => this.handleValueChanged(propertyMetadata.ValueField, value),
                        value: value,
                        label: propertyMetadata.Label,
                        customProps: resolvedEditor.customProps
                    }
                    return React.createElement(resolvedEditor.component, props);
                }

            }
        }
    }

    render() {
        var editControls = this.props.properties.map(this.typeToControl);

        return (
            <div className="dg main" style={{ paddingLeft: (this.props.level > 0 ? 1 : 0) * 15 + "px" }}>
                <ul>
                    {editControls}
                </ul>
            </div>
        );
    }
};
interface ListPropertiesEditorExtProps {
    contextVariables: any;
    properties: any;
    selectedElement: any;
    onValueChanged: any;
    label: any;
    selectedRootElement: any;
    level: any;
    propertyMetadata: propertyTypes.ObjectListPropertyExt;
    isReadOnly: boolean;
    translations?;
    customComponentResolver?: any;
}

export class ListPropertiesEditorExt extends React.Component<ListPropertiesEditorExtProps, any> {
    constructor(props) {
        super(props);
        this.state = { selectedIndex: -1 }
    }
    handleObjectTypeChanged = (objectMetadata: propertyTypes.ObjectListPropertyExt, key: string, index: number) => {

        let state = null;
        state = objectMetadata.createNewStateImplementationInstance(key);
        const newArray = this.props.selectedElement;
        newArray[index] = state;

        this.props.onValueChanged((newArray));
    }
    handleValueChanged = (obj, propertyName, value) => {
        obj[propertyName] = value;
        this.props.onValueChanged((this.props.selectedElement));
    }

    handleDeleteRow = (obj) => {
        this.props.selectedElement.filter
        var newArray = this.props.selectedElement.filter(i => i != obj);
        this.props.onValueChanged((newArray));
    }

    handleMoveElementUp = (oldIndex) => {
        var newArray = move(this.props.selectedElement, oldIndex, oldIndex - 1);
        this.setState({ selectedIndex: oldIndex - 1 });
        this.props.onValueChanged((newArray));
    }

    handleMoveElementDown = (oldIndex) => {
        var newArray = move(this.props.selectedElement, oldIndex, oldIndex + 1);
        this.setState({ selectedIndex: oldIndex + 1 });
        this.props.onValueChanged((newArray));
    }

    handleElementClick = (index) => {
        this.setState({ selectedIndex: index });
    }

    generateOptionList = (objInRow, index, count) => {
        let options;
        let meta = this.props.propertyMetadata as propertyTypes.ObjectListPropertyExt
        if (meta.getAllKeys) {
            options = meta.getAllKeys().map((k) => { return { Key: k, Value: k } });
        }
        const header = this.props.isReadOnly ? null : < ItemHeader key={index}
            contextVariables={this.props.contextVariables}
            options={options}
            onTextChange={(value) => (this.handleObjectTypeChanged(meta, value, index))}
            value={objInRow[meta.objectTypeField]}
            onMoveUpClicked={() => this.handleMoveElementUp(index)}
            onMoveDownClicked={() => this.handleMoveElementDown(index)}
            onDeleteClicked={() => this.handleDeleteRow(objInRow)}
            moveUpDisabled={index === 0}
            moveDownDisabled={index === count - 1} />;

        const optionsList = (
            <div style={{}}>
                {header}
            </div>);
        return optionsList;
    }

    getEditorForElementInRow = (objInRow: propertyTypes.BaseComponentProps, index, count) => {
        let propsByKey = objInRow.getMetadata();
        return (
            <div style={{ borderBottomStyle: "solid", borderColor: "gray", borderWidth: "1px" }}>
                {this.generateOptionList(objInRow, index, count)}
                <div style={{ paddingLeft: (this.props.level > 0 ? 1 : 0) * 15 + "px" }}>
                    <ListPropertyItem
                        componentState={objInRow}
                        level={0}
                        contextVariables={this.props.contextVariables}
                        properties={propsByKey}
                        selectedElement={objInRow}
                        onValueChanged={(name, value) => (this.handleValueChanged(objInRow, name, value))}
                        onItemClicked={() => (this.handleElementClick(index))}
                        selectedRootElement={this.props.selectedRootElement}
                        customComponentResolver={this.props.customComponentResolver}
                        translations={this.props.translations} />
                </div>
            </div>)
    }

    render() {
        var index = 0;
        var that = this;
        if (Array.isArray(this.props.selectedElement)) {
            var objectEditor = this.props.selectedElement.map(function (element) { return that.getEditorForElementInRow(element, index++, that.props.selectedElement.length) });
        }
        return (
            <div>
                {objectEditor}
            </div >
        );
    }
};

export class ListPropertyItem extends React.Component<any, any> {
    handleElementClick = () => {
        this.props.onItemClicked();
    }

    handleValueChanged = (obj, propertyName, value) => {
        obj[propertyName] = value;
        let newValue = this.props.selectedElement;
        this.props.onValueChanged(value);
    }

    render() {
        var buttons = null;

        return <div onClick={this.handleElementClick}>
            <ObjectPropertiesEditor
                componentState={this.props.componentState}
                level={this.props.level}
                contextVariables={this.props.contextVariables}
                properties={this.props.properties}
                selectedElement={this.props.selectedElement}
                onValueChanged={(name, value) => this.handleValueChanged(this.props.selectedElement, name, value)}
                translations={this.props.translations}
                customComponentResolver={this.props.customComponentResolver}
                selectedRootElement={this.props.selectedRootElement} />
        </div>;
    }
};

export class ServiceSelectorDialog extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        new ApiBuilder().GetAllServicesOfType(this.props.dataSourceType || 0, (result) => {
            this.setState({ services: result });
        });
    }

    handleSave = (selectedItem) => {
        if (this.props.export === true) {
            this.props.onSave("api/dynamicapi/" + selectedItem.Id + "/GetExportFile");
        }
        else {
            this.props.onSave("api/dynamicapi/" + selectedItem.Id + "/GetData");
        }
    }

    private dialogProps: DialogProps = {
        title: "Select service",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.props.onClose();
                    return true;
                }
            }
        ],
        afterClose: () => {
            if (!this.state.searchOpened) {
                this.props.onClose && this.props.onClose();
            }
        },
        width: 500,
        open: true
    }

    render() {
        var columns = [{
            field: "ServiceName", title: "Service", filterable: {
                cell: {
                    operator: "contains",
                    template: function (args) {
                        args.element.css("width", "90%").addClass("k-textbox").keydown(function (e) {
                            setTimeout(function () {
                                $(e.target).trigger("change");
                            });
                        });
                    },
                    showOperators: false
                }
            }
        }];

        return (
            <Dialog {...this.dialogProps}>
                <react_components.KendoGrid filtermode="row" data={this.state.services} columns={columns} OnSelectedItemChanged={this.handleSave} />
            </Dialog>

        );
    }
};
export class ColumnPickerDialog extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    private dialogProps: DialogProps = {
        title: "Select service",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.handleClose();
                    return true;
                }
            }
        ],
        afterClose: () => {
            if (!this.state.searchOpened) {
                this.props.onClose && this.props.onClose();
            }
        },
        width: 500,
        open: true
    }

    componentDidMount() {
        var that = this;
        utility.httpService.get("api/dynamicapi/" + this.props.serviceId + "/GetServiceMetadataById", {}, function (data) {
            that.setState({ services: data });
        });
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = (selectedItem) => {
        this.props.onSave(selectedItem.ColumnName);
    }

    render() {
        var columns = [{ field: "ColumnName", title: "Column name" }];

        return (
            <Dialog {...this.dialogProps}>
                <react_components.KendoGrid filtermode="row" data={this.state.services} columns={columns} OnSelectedItemChanged={this.handleSave} />
            </Dialog>
        );
    }
};

export class EntityFieldPickerDialog extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        var that = this;
        utility.httpService.get("api/dynamicapi/" + this.props.serviceId + "/GetServiceMetadataById", {}, function (data) {
            that.setState({ services: data });
        });
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = (selectedItem) => {
        this.props.onSave(selectedItem.ColumnName);
    }

    render() {
        var columns = [{ field: "ColumnName", title: "Column name" }];

        return (
            <div className="modal fade show in">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" onClick={this.handleClose}>
                                <span aria-hidden="true">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                            <h4 className="modal-title">Select column</h4>
                        </div>
                        <div className="modal-body" style={{ height: "600px", overflow: "auto" }}>
                            <react_components.KendoGrid filtermode="row" data={this.state.services} columns={columns} OnSelectedItemChanged={this.handleSave} />
                        </div>
                        <div className="modal-footer">
                            <UiBuildertoolBar>
                                <react_components.InnoButtonOkay onClick={this.handleSave} label="Okay"></react_components.InnoButtonOkay>
                                <react_components.InnoButtonCancel onClick={this.handleClose} label="Close"></react_components.InnoButtonCancel>
                            </UiBuildertoolBar>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

class TranslationPickerControl extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = { showServiceSelector: false, currentValue: props.value, initialValue: props.value };
    }

    handleShowServiceSelector = () => {
        this.setState({ showServiceSelector: true });
    }

    handleClose = () => {
        this.setState({ showServiceSelector: false });
    }

    handleSave = (name) => {
        this.props.onTextChange('{{{' + name + '}}}');
        this.setState({ showServiceSelector: false });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ currentValue: props.value, initialValue: props.value });
    }

    handleChange = (event) => {
        this.setState({ currentValue: event.target.value });
    }

    handleBlur = (event) => {
        if (this.state.currentValue != this.state.initialValue) {
            this.props.onTextChange(this.state.currentValue);
        }
    }

    extractServiceId(url) {
        if (url) {
            var index = url.substring(15, url.length);
            index = index.substring(0, url.indexOf('/') - 1);
            return index;
        }
        return url;
    }

    render() {
        var d;

        if (this.state.showServiceSelector === true) {
            d = <translations_editor.TranslationsEditor contextVariables={this.props.contextVariables} onClose={this.handleClose} onSave={this.handleSave} />
        }
        return (
            <li>
                {d}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowServiceSelector}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        <input type="text" value={this.state.currentValue || ''} onChange={this.handleChange} onBlur={this.handleBlur} />
                    </div>
                </div>
            </li>
        );
    }
};

class ColumnPickerControl extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = { currentValue: props.value, initialValue: props.value };
    }

    handleShowServiceSelector = () => {
        let b = this.props.meta.getDataSource && this.props.meta.getDataSource();
        const serviceId = this.extractServiceId((b || this.props.selectedRootElement[this.props.serviceProperty]) || this.props.selectedRootElement["dataSource"]);
        if (serviceId) {
            this.setState({ showServiceSelector: true });
        }
    }

    handleClose = () => {
        this.setState({ showServiceSelector: false });
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
        this.setState({ showServiceSelector: false });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ currentValue: props.value, initialValue: this.props.value });
    }

    handleChange = (event) => {
        this.setState({ currentValue: event.target.value });
    }

    handleBlur = (event) => {
        if (this.state.currentValue != this.state.initialValue) {
            this.props.onTextChange(event.target.value);
        }
    }

    extractServiceId = (dataSource) => {
        let dataUrl = dataSource;
        if (dataSource) {
            if (typeof dataUrl === "object") {
                if (dataSource["_Object_Type"] == "sql") {
                    dataUrl = dataSource.dataUrl;
                }
                else {
                    DialogHelper.alert("Columnpicker is currently only implemented for data sources of type 'sql'");
                    return null
                }
            }
            if (dataUrl) {
                var index = dataUrl.substring(15, dataSource.length);
                index = index.substring(0, index.indexOf('/'));
                return index;
            }
        }
        return dataUrl;

    }

    render() {
        let d;

        if (this.state.showServiceSelector === true) {
            let b = this.props.meta.getDataSource && this.props.meta.getDataSource();
            const serviceId = this.extractServiceId((b || this.props.selectedRootElement[this.props.serviceProperty]) || this.props.selectedRootElement["dataSource"]);
            d = <ColumnPickerDialog onClose={this.handleClose} onSave={this.handleSave} export={this.props.export} serviceId={serviceId} />
        }
        return (
            <li>
                {d}
                <div title={this.props.label}>
                    <span className="property-name" >
                        <RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowServiceSelector}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        <input type="text" value={this.state.currentValue || ''} onChange={this.handleChange} onBlur={this.handleBlur} />
                    </div>
                </div>
            </li>
        );
    }
};

class DocumentPickerControl extends React.Component<{ onTextChange: any, value: string, label: string }, any> {

    handleShowServiceSelector = () => {
        const componentHelper = ComponentHelper.createFactory();
        const componentSearchProps = componentHelper.getDefaultSearchFieldProps();
        componentSearchProps.field.searchWindowUrl = "DynamicSearch/Window/crPicture?fullObject=true";
        new SearchHelper().openSearch(componentSearchProps, this.handleFieldClicked, this.handleObjectChanged, () => this.setState({ searchOpened: true }));
    }

    handleFieldClicked = (field: { model: string }, value: any, dataItem?: any) => {
        this.props.onTextChange(value);
    }

    handleObjectChanged = (field: { model: string }, object: any) => {
        this.props.onTextChange(object.Id);
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
        this.setState({ showServiceSelector: false });
    }

    render() {

        return (
            <li>
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowServiceSelector}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        {this.props.value}
                    </div>
                </div>
            </li>
        );
    }
};

class ServicePickerControl extends React.Component<{ contextVariables: any, onTextChange: any, dataSourceType: string, export: boolean, value: string, label: string, useOnlyServiceID: boolean }, any> {
    constructor(props) {
        super(props);
        this.state = { showServiceSelector: false };
    }

    handleShowServiceSelector = () => {
        this.setState({ showServiceSelector: true });
    }

    handleClose = () => {
        this.setState({ showServiceSelector: false });
    }

    handleSave = (name) => {
        if (this.props.useOnlyServiceID) {
            name = this.extractServiceId(name);
        }
        this.props.onTextChange(name);
        this.setState({ showServiceSelector: false });
    }

    extractServiceId = (url: string) => {
        if (url) {
            const end = url.lastIndexOf('/');
            if (end > -1) {
                let index = url.substring(end - 36, end);
                return index;
            }
        }
        return url;
    }

    render() {
        var d;
        if (this.state.showServiceSelector === true) {
            d = <ServiceSelectorDialog onClose={this.handleClose} onSave={this.handleSave} export={this.props.export} dataSourceType={this.props.dataSourceType} />
        }
        var link = this.props.value ? <a target="_blank" href={this.props.contextVariables.INNO_BASE_PATH + `Statistic/apiBuilderDetail?id=${this.extractServiceId(this.props.value)}`}>View datasource</a> : null;

        return (
            <li>
                {d}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowServiceSelector}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        {link}
                    </div>
                </div>
            </li>
        );
    }
};
function move(array: any[], oldIndex: number, newIndex: number) {
    if (newIndex >= array.length) {
        var k = newIndex - array.length;
        while ((k--) + 1) {
            array.push(undefined);
        }
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    return array; // for testing purposes
}


export class DropDownList extends React.Component<any, any> {
    private dropDownList: any;
    constructor(props) {
        super(props);
        this.state = { page: 0, isLoading: false };
    }

    getData = () => {
        var that = this;
        if (this.props.dataUrl) {
            this.setState({ isLoading: true });
            utility.httpService.get(this.props.dataUrl, {}, function (data) {
                that.setState({ values: data, isLoading: false });
            });
        } else if (typeof (this.props.data) !== 'undefined') {
            that.setState({ values: this.props.data });
        }
    }

    componentDidMount() {
        var that = this;
        var $rootNode = $(this.refs.dropDownList);

        const props: kendo.ui.DropDownListOptions = {
            dataTextField: this.props.valueField,
            dataValueField: this.props.keyField,
            change: function () {
                var value = this.value();
                that.props.onChange(value);
            }
        }

        if (this.props.filter) {
            props.filter = this.props.filter;
        }

        var list = $rootNode.kendoDropDownList(props);
        this.dropDownList = list.data("kendoDropDownList");
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.values !== prevState.values) {
            this.dropDownList.dataSource.data(this.state.values);
        }

        if (Array.isArray(this.props.value)) {
            this.dropDownList.value(this.props.value.slice());

        }
        else {
            this.dropDownList.value([this.props.value]);
        }

        if (this.props.dataUrl !== prevProps.dataUrl || this.props.data !== prevProps.data) {
            this.getData();
        }
    }

    render() {
        var style = { width: "100%" };
        if (this.state.isLoading) {
            var spinner = <img src="Content/img/spinner.gif" />
        }
        return (<react_components.ReactColumn width={this.props.width}>
            <div className="form-group">
                <label>{this.props.label}</label> {spinner}
                <input ref="dropDownList" name={this.props.name} style={style} value={this.props.value}></input>
            </div>
        </react_components.ReactColumn>)
    }
};

export class SavingDialog extends React.Component<any, any> {
    handleClose = () => {
        this.props.onClose();
    }

    render() {
        var title = "Saving...";
        return <div className="modal fade show in">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" onClick={this.handleClose}><span className="sr-only">Close</span></button>
                        <h4 className="modal-title">{title}</h4>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        </div>;
    }
};


export class BusyIndicatorDialog extends React.Component<any, any> {
    handleClose = () => {
        this.props.onClose();
    }

    render() {
        var title = this.props.title || "...";
        return <div className="modal fade show in">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" onClick={this.handleClose}><span className="sr-only">Close</span></button>
                        <div style={{ display: "inline" }}>
                            <img style={{ display: "inline" }} src="/Content/kendo/Uniform/loading-image.gif" />
                            <h4 style={{ display: "inline" }} className="modal-title">{title}</h4>
                        </div>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        </div>;
    }
};

export class ButtonScalor extends React.Component<any, any> {
    render() {
        return (<div style={{ transform: "scale(0.6) translate(3px, 3px)", transformOrigin: "top left", display: "inline-block" }}>{this.props.children}</div>)
    }
}

export class RightFloatingButtonScalor extends React.Component<any, any> {
    render() {
        return <div style={{
            height: "27px",
            width: "32px",
            transform: "scale(0.7) translate(0px,-3px)",
            "float": "right",
            padding: "0px"
        }} className="innoOptionsButton innoOptionsSearch">
            {this.props.children}
        </div>
    }
}